__turbopack_context__.v({
  "badge": "index-module__sqbL5G__badge",
  "default": "index-module__sqbL5G__default",
  "error": "index-module__sqbL5G__error",
  "info": "index-module__sqbL5G__info",
  "medium": "index-module__sqbL5G__medium",
  "neutral": "index-module__sqbL5G__neutral",
  "small": "index-module__sqbL5G__small",
  "warning": "index-module__sqbL5G__warning",
});
